import axios from 'axios';
import Cookies from 'universal-cookie';
import { addDays, addMinutes } from 'date-fns';
import AuthProvider from './authProvider';
import { getAbortController, removeAbortController } from './abortControllerManager';
import { redirect } from 'react-router-dom';

const api = axios.create({
  baseURL: `https://${window.location.hostname}:${window.location.port}`, // Подставляем текущий хост и порт
});

const cookies = new Cookies();

api.interceptors.request.use(
  (config) => {
    const accessToken = cookies.get('access');
    if (accessToken) {
      config.headers['Authorization'] = 'Bearer ' + accessToken;
    }
    const controller = getAbortController(config.url);
    config.signal = controller.signal;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  async (response) => {
    removeAbortController(response.config.url);
    return response;
  },
  async (error) => {
    if (axios.isCancel(error)) {
      console.warn('Request canceled', error.message);
      return Promise.reject(error);
    }
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = cookies.get('refresh');

      if (!refreshToken) {
        await AuthProvider.signout();
        return Promise.reject(error);
      }
      try {
        const response = await axios.post('/api/token/refresh/', { refresh: refreshToken });
        if (response.status === 200) {

          const refreshExpires = addDays(new Date(), 1);
          cookies.set('refresh', refreshToken, { sameSite: 'lax', expires: refreshExpires, path: '/' });

          const accessExpires = addMinutes(new Date(), 5);
          cookies.set('access', response.data.access, { sameSite: 'lax', expires: accessExpires, path: '/' });

          api.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access;
          originalRequest.headers['Authorization'] = 'Bearer ' + response.data.access;
          return api(originalRequest);
        }
      } catch (err) {
        if (error.response && error.response.status === 401) {
          await AuthProvider.signout();
          const params = new URLSearchParams();
          params.set("from", new URL(window.location.href).pathname);
          throw redirect('/login?' + params.toString());
        }
        return Promise.reject(error);// */
      }
    }
    return Promise.reject(error);
  }
);

export default api;
